import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-badges-example',
  templateUrl: './badges.component.html',
})
export class KitBootstrapBadgesExampleComponent {}
